import Service from "../Service";

const resource = "CntBudgetAgile/";

export default {
    
    save(budget, requestID) {
        return Service.post(resource + "save", budget, {
            params: { requestID: requestID},
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
};